'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openTermsModal = exports.openUpdatePasswordModal = exports.openSetPasswordModal = exports.openSendSellerMessageModal = exports.openSendSellerConsignmentMessageModal = exports.openRetractBidModal = exports.openRegisterForCatalogModal = exports.openAbstenteeBidModal = exports.openLoginModal = exports.openLiveBidModal = exports.openItemDescriptionModal = exports.openInstallFlashModal = exports.openHealthcheckModal = exports.openForgotPasswordModal = exports.openDownloadMobileModal = exports.openCreateAccountModal = exports.openConsignmentConfirmModal = exports.openConfirmPasswordModal = exports.openCompleteAccountModal = exports.openBuyNowModal = exports.openAddSearchAlertModal = exports.openAddCreditCardModal = exports.dismissModal = exports.completeSendSellerMessageModal = exports.completeLoginModal = exports.closeModalAndCheckCreditCard = exports.getOpenModal = exports.OPEN_TERMS_MODAL = exports.OPEN_SET_PASSWORD_MODAL = exports.OPEN_SEND_SELLER_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = exports.OPEN_RETRACT_BID_MODAL = exports.OPEN_REGISTER_FOR_CATALOG_MODAL = exports.OPEN_LOGIN_MODAL = exports.OPEN_LIVE_BID_MODAL = exports.OPEN_ITEM_DESCRIPTION_MODAL = exports.OPEN_INSTALL_FLASH_MODAL = exports.OPEN_HEALTHCHECK_MODAL = exports.OPEN_FORGOT_PASSWORD_MODAL = exports.OPEN_DOWNLOAD_MOBILE_MODAL = exports.OPEN_CREATE_ACCOUNT_MODAL = exports.OPEN_CONSIGNMENT_CONFIRM_MODAL = exports.OPEN_CONFIRM_PASSWORD_MODAL = exports.OPEN_COMPLETE_ACCOUNT_MODAL = exports.OPEN_CLASSIC_BIDDING_CONSOLE_MODAL = exports.OPEN_CHANGE_PASSWORD_MODAL = exports.OPEN_BUY_NOW_MODAL = exports.OPEN_ADD_SEARCH_ALERT_MODAL = exports.OPEN_ADD_CREDIT_CARD_MODAL = exports.OPEN_ABSENTEE_BID_MODAL = exports.DISMISS_MODAL = exports.COMPLETE_SEND_SELLER_MESSAGE_MODAL = exports.COMPLETE_LOGIN_MODAL = exports.COMPLETE_CONFIRM_PASSWORD_MODAL = exports.COMPLETE_COMPLETE_ACCOUNT_MODAL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _shouldLogin = require('./shouldLogin');

var _completeAccount = require('./completeAccount');

var _createAccount = require('./createAccount');

var _reselect = require('reselect');

var _forgotPassword = require('./forgotPassword');

var _user = require('./user');

var _login = require('./login');

var _enums = require('../../enums');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var COMPLETE_COMPLETE_ACCOUNT_MODAL = exports.COMPLETE_COMPLETE_ACCOUNT_MODAL = 'COMPLETE_COMPLETE_ACCOUNT_MODAL';
var COMPLETE_CONFIRM_PASSWORD_MODAL = exports.COMPLETE_CONFIRM_PASSWORD_MODAL = 'COMPLETE_CONFIRM_PASSWORD_MODAL';
var COMPLETE_LOGIN_MODAL = exports.COMPLETE_LOGIN_MODAL = 'COMPLETE_LOGIN_MODAL'; // this is not used.  LOGIN_SUCCESS is used instead.
var COMPLETE_SEND_SELLER_MESSAGE_MODAL = exports.COMPLETE_SEND_SELLER_MESSAGE_MODAL = 'COMPLETE_SEND_SELLER_MESSAGE_MODAL';
var DISMISS_MODAL = exports.DISMISS_MODAL = 'DISMISS_MODAL';
var OPEN_ABSENTEE_BID_MODAL = exports.OPEN_ABSENTEE_BID_MODAL = 'OPEN_ABSENTEE_BID_MODAL';
var OPEN_ADD_CREDIT_CARD_MODAL = exports.OPEN_ADD_CREDIT_CARD_MODAL = 'OPEN_ADD_CREDIT_CARD_MODAL';
var OPEN_ADD_SEARCH_ALERT_MODAL = exports.OPEN_ADD_SEARCH_ALERT_MODAL = 'OPEN_ADD_SEARCH_ALERT_MODAL';
var OPEN_BUY_NOW_MODAL = exports.OPEN_BUY_NOW_MODAL = 'OPEN_BUY_NOW_MODAL';
var OPEN_CHANGE_PASSWORD_MODAL = exports.OPEN_CHANGE_PASSWORD_MODAL = 'OPEN_CHANGE_PASSWORD_MODAL';
var OPEN_CLASSIC_BIDDING_CONSOLE_MODAL = exports.OPEN_CLASSIC_BIDDING_CONSOLE_MODAL = 'OPEN_CLASSIC_BIDDING_CONSOLE_MODAL';
var OPEN_COMPLETE_ACCOUNT_MODAL = exports.OPEN_COMPLETE_ACCOUNT_MODAL = 'OPEN_COMPLETE_ACCOUNT_MODAL';
var OPEN_CONFIRM_PASSWORD_MODAL = exports.OPEN_CONFIRM_PASSWORD_MODAL = 'OPEN_CONFIRM_PASSWORD_MODAL';
var OPEN_CONSIGNMENT_CONFIRM_MODAL = exports.OPEN_CONSIGNMENT_CONFIRM_MODAL = 'OPEN_CONSIGNMENT_CONFIRM_MODAL';
var OPEN_CREATE_ACCOUNT_MODAL = exports.OPEN_CREATE_ACCOUNT_MODAL = 'OPEN_CREATE_ACCOUNT_MODAL';
var OPEN_DOWNLOAD_MOBILE_MODAL = exports.OPEN_DOWNLOAD_MOBILE_MODAL = 'OPEN_DOWNLOAD_MOBILE_MODAL';
var OPEN_FORGOT_PASSWORD_MODAL = exports.OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
var OPEN_HEALTHCHECK_MODAL = exports.OPEN_HEALTHCHECK_MODAL = 'OPEN_HEALTHCHECK_MODAL';
var OPEN_INSTALL_FLASH_MODAL = exports.OPEN_INSTALL_FLASH_MODAL = 'OPEN_INSTALL_FLASH_MODAL';
var OPEN_ITEM_DESCRIPTION_MODAL = exports.OPEN_ITEM_DESCRIPTION_MODAL = 'OPEN_ITEM_DESCRIPTION_MODAL';
var OPEN_LIVE_BID_MODAL = exports.OPEN_LIVE_BID_MODAL = 'OPEN_LIVE_BID_MODAL';
var OPEN_LOGIN_MODAL = exports.OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
var OPEN_REGISTER_FOR_CATALOG_MODAL = exports.OPEN_REGISTER_FOR_CATALOG_MODAL = 'OPEN_REGISTER_FOR_CATALOG_MODAL';
var OPEN_RETRACT_BID_MODAL = exports.OPEN_RETRACT_BID_MODAL = 'OPEN_RETRACT_BID_MODAL';
var OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL = 'OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL';
var OPEN_SEND_SELLER_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_MESSAGE_MODAL = 'OPEN_SEND_SELLER_MESSAGE_MODAL';
var OPEN_SET_PASSWORD_MODAL = exports.OPEN_SET_PASSWORD_MODAL = 'OPEN_SET_PASSWORD_MODAL';
var OPEN_TERMS_MODAL = exports.OPEN_TERMS_MODAL = 'OPEN_TERMS_MODAL';
// reducer
var DEFAULT_STATE = {
    modal: _enums.modalTypes.NONE
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
        case COMPLETE_COMPLETE_ACCOUNT_MODAL:
        case COMPLETE_SEND_SELLER_MESSAGE_MODAL:
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
        case DISMISS_MODAL:
        case _login.LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.NONE
            });
        case OPEN_ADD_SEARCH_ALERT_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ADD_SEARCH_ALERT
            });
        case OPEN_ADD_CREDIT_CARD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ADD_CREDIT_CARD
            });
        case OPEN_ABSENTEE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ABSENTEE_BID
            });
        case OPEN_BUY_NOW_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.BUY_NOW
            });
        case OPEN_CLASSIC_BIDDING_CONSOLE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CLASSIC_BIDDING_CONSOLE
            });
        case OPEN_COMPLETE_ACCOUNT_MODAL:
        case _shouldLogin.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.COMPLETE_ACCOUNT
            });
        case OPEN_CREATE_ACCOUNT_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SIGN_UP
            });
        case OPEN_DOWNLOAD_MOBILE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.DOWNLOAD_MOBILE
            });
        case OPEN_HEALTHCHECK_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.HEALTHCHECK
            });
        case OPEN_INSTALL_FLASH_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.INSTALL_FLASH
            });
        case OPEN_ITEM_DESCRIPTION_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ITEM_DESCRIPTION
            });
        case OPEN_CHANGE_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CHANGE_PASSWORD
            });
        case OPEN_CONFIRM_PASSWORD_MODAL:
        case _shouldLogin.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CONFIRM_PASSWORD
            });
        case OPEN_CONSIGNMENT_CONFIRM_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CONFIRM_CONSIGNMENT
            });
        case _forgotPassword.FORGOT_PASSWORD_FAIL:
        case OPEN_FORGOT_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.FORGOT_PASSWORD
            });
        case OPEN_LIVE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.LIVE_BID
            });
        case OPEN_LOGIN_MODAL:
        case _shouldLogin.OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.LOGIN
            });
        case OPEN_RETRACT_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.RETRACT_BID
            });
        case OPEN_REGISTER_FOR_CATALOG_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.REGISTER_FOR_AUCTION
            });
        case OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SEND_SELLER_CONSIGNMENT_MESSAGE
            });
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SEND_SELLER_MESSAGE
            });
        case OPEN_SET_PASSWORD_MODAL:
        case _shouldLogin.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SET_PASSWORD
            });
        case OPEN_TERMS_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.TERMS
            });
        default:
            return state;
    }
}

/* SELECTORS */
var modalSelector = function modalSelector(state) {
    return state.ui.modal;
};

var getOpenModal = exports.getOpenModal = (0, _reselect.createSelector)(modalSelector, function (modal) {
    return modal.modal || _enums.modalTypes.NONE;
});

/* ACTION CREATORS */
var closeModalAndCheckCreditCard = exports.closeModalAndCheckCreditCard = function closeModalAndCheckCreditCard(preventAddCreditCardModal) {
    return function (dispatch, getState) {
        var state = getState();

        var _getUserData = (0, _user.getUserData)(state),
            creditCardValidated = _getUserData.creditCardValidated;

        dispatch(dismissModal());
        if (!creditCardValidated && !preventAddCreditCardModal) {
            dispatch(openAddCreditCardModal());
        }
    };
};

var completeLoginModal = exports.completeLoginModal = function completeLoginModal() {
    return {
        type: COMPLETE_LOGIN_MODAL
    };
};

var completeSendSellerMessageModal = exports.completeSendSellerMessageModal = function completeSendSellerMessageModal() {
    return {
        type: COMPLETE_SEND_SELLER_MESSAGE_MODAL
    };
};

var dismissModal = exports.dismissModal = function dismissModal() {
    return {
        type: DISMISS_MODAL
    };
};

var openAddCreditCardModal = exports.openAddCreditCardModal = function openAddCreditCardModal() {
    return {
        type: OPEN_ADD_CREDIT_CARD_MODAL
    };
};

var openAddSearchAlertModal = exports.openAddSearchAlertModal = function openAddSearchAlertModal() {
    return {
        type: OPEN_ADD_SEARCH_ALERT_MODAL
    };
};

var openBuyNowModal = exports.openBuyNowModal = function openBuyNowModal(_ref) {
    var itemId = _ref.itemId,
        modalType = _ref.modalType,
        offerPrice = _ref.offerPrice;
    return {
        payload: { itemId: itemId, modalType: modalType, offerPrice: offerPrice },
        type: OPEN_BUY_NOW_MODAL
    };
};

var openCompleteAccountModal = exports.openCompleteAccountModal = function openCompleteAccountModal() {
    return {
        type: OPEN_COMPLETE_ACCOUNT_MODAL
    };
};

var openConfirmPasswordModal = exports.openConfirmPasswordModal = function openConfirmPasswordModal(payload) {
    return {
        payload: payload,
        type: OPEN_CONFIRM_PASSWORD_MODAL
    };
};

var openConsignmentConfirmModal = exports.openConsignmentConfirmModal = function openConsignmentConfirmModal() {
    return {
        type: OPEN_CONSIGNMENT_CONFIRM_MODAL
    };
};

var openCreateAccountModal = exports.openCreateAccountModal = function openCreateAccountModal() {
    return {
        type: OPEN_CREATE_ACCOUNT_MODAL
    };
};

var openDownloadMobileModal = exports.openDownloadMobileModal = function openDownloadMobileModal() {
    return {
        type: OPEN_DOWNLOAD_MOBILE_MODAL
    };
};

var openForgotPasswordModal = exports.openForgotPasswordModal = function openForgotPasswordModal() {
    return {
        type: OPEN_FORGOT_PASSWORD_MODAL
    };
};

var openHealthcheckModal = exports.openHealthcheckModal = function openHealthcheckModal() {
    return {
        type: OPEN_HEALTHCHECK_MODAL
    };
};

var openInstallFlashModal = exports.openInstallFlashModal = function openInstallFlashModal() {
    return {
        type: OPEN_INSTALL_FLASH_MODAL
    };
};

var openItemDescriptionModal = exports.openItemDescriptionModal = function openItemDescriptionModal(itemId) {
    return {
        payload: itemId,
        type: OPEN_ITEM_DESCRIPTION_MODAL
    };
};

var openLiveBidModal = exports.openLiveBidModal = function openLiveBidModal(itemId, bidAmount) {
    return {
        payload: { bidAmount: bidAmount, itemId: itemId },
        type: OPEN_LIVE_BID_MODAL
    };
};

var openLoginModal = exports.openLoginModal = function openLoginModal() {
    return {
        type: OPEN_LOGIN_MODAL
    };
};

var openAbstenteeBidModal = exports.openAbstenteeBidModal = function openAbstenteeBidModal(itemId, bidAmount) {
    return {
        payload: { bidAmount: bidAmount, itemId: itemId },
        type: OPEN_ABSENTEE_BID_MODAL
    };
};

var openRegisterForCatalogModal = exports.openRegisterForCatalogModal = function openRegisterForCatalogModal(_ref2) {
    var catalogId = _ref2.catalogId,
        _ref2$fromBiddingCons = _ref2.fromBiddingConsole,
        fromBiddingConsole = _ref2$fromBiddingCons === undefined ? false : _ref2$fromBiddingCons;
    return {
        payload: { catalogId: catalogId, fromBiddingConsole: fromBiddingConsole },
        type: OPEN_REGISTER_FOR_CATALOG_MODAL
    };
};

var openRetractBidModal = exports.openRetractBidModal = function openRetractBidModal(itemId) {
    return {
        payload: { itemId: itemId },
        type: OPEN_RETRACT_BID_MODAL
    };
};

var openSendSellerConsignmentMessageModal = exports.openSendSellerConsignmentMessageModal = function openSendSellerConsignmentMessageModal(messageDetails, sellerId, sellerName, subject, title) {
    return {
        payload: { messageDetails: messageDetails, sellerId: sellerId, sellerName: sellerName },
        type: OPEN_SEND_SELLER_CONSIGNMENT_MESSAGE_MODAL
    };
};

var openSendSellerMessageModal = exports.openSendSellerMessageModal = function openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject, title) {
    return {
        payload: { messageDetails: messageDetails, sellerId: sellerId, sellerName: sellerName, subject: subject, title: title },
        type: OPEN_SEND_SELLER_MESSAGE_MODAL
    };
};

var openSetPasswordModal = exports.openSetPasswordModal = function openSetPasswordModal() {
    return {
        type: OPEN_SET_PASSWORD_MODAL
    };
};

var openUpdatePasswordModal = exports.openUpdatePasswordModal = function openUpdatePasswordModal() {
    return {
        type: OPEN_CHANGE_PASSWORD_MODAL
    };
};

var openTermsModal = exports.openTermsModal = function openTermsModal(catalogId) {
    return {
        payload: { catalogId: catalogId },
        type: OPEN_TERMS_MODAL
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/modal.js
// module id = u90i
// module chunks = 60